import { AlpabetIcon, DebateAlpabetIcon, OIcon, XIcon } from "./Icons";

// 선택지 타입 판단
export const detectOptionType = (obj: any) => {
  const keys = Object.keys(obj);

  const isOX = keys.every((key) => key === "option_O" || key === "option_X");
  if (isOX) return "OX";

  const isNumeric = keys.every((key) => /^option_\d+$/.test(key)); // option_1, option_2 형식 체크
  if (isNumeric) return "Numeric";

  return "Unknown"; // 다른 형식일 경우
};

// 이긴 선택지 판단
export const getWinningChoice = (obj: any) => {
  const winningChoice = Object.values(obj).reduce(
    (max: any, opt: any) => (opt.votes > (max?.votes ?? 0) ? opt : max),
    null
  );

  // const winningChoice = Object.entries(obj).reduce(
  //   (max: any, [key, value]: any) =>
  //     value.votes > (max?.votes ?? 0)
  //       ? {
  //           optionKey: key,
  //           optionValue: value.value,
  //           votes: value.votes,
  //         }
  //       : max,
  //   null
  // );

  return winningChoice;
};

// 선택지 아이콘
export const getWiningIcon = (symbol: string, size = 12) => {
  let discussWiniingIcon = null;

  if (symbol === "O") {
    discussWiniingIcon = <OIcon size={size} />;
  } else if (symbol === "X") {
    discussWiniingIcon = <XIcon size={size} />;
  } else {
    discussWiniingIcon = <AlpabetIcon alphabet={symbol} />;
  }

  return discussWiniingIcon;
};

// Debate 선택지 아이콘
export const getDebateWiningIcon = (symbol: string, size = 12) => {
  if (symbol === "O") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="11"
        viewBox="0 0 10 11"
        fill="none"
      >
        <g clipPath="url(#clip0_20220_19643)">
          <path
            d="M0.0546875 3.85135C0.0546875 2.02957 1.53153 0.552734 3.3533 0.552734H6.65191C8.47368 0.552734 9.95052 2.02957 9.95052 3.85135V7.14996C9.95052 8.97173 8.47368 10.4486 6.65191 10.4486H3.3533C1.53153 10.4486 0.0546875 8.97173 0.0546875 7.14996V3.85135Z"
            fill="var(--blue50)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.99884 7.14815C5.90973 7.14815 6.64815 6.40973 6.64815 5.49884C6.64815 4.58796 5.90973 3.84954 4.99884 3.84954C4.08796 3.84954 3.34954 4.58796 3.34954 5.49884C3.34954 6.40973 4.08796 7.14815 4.99884 7.14815ZM4.99884 8.24769C6.51699 8.24769 7.74769 7.01699 7.74769 5.49884C7.74769 3.9807 6.51699 2.75 4.99884 2.75C3.4807 2.75 2.25 3.9807 2.25 5.49884C2.25 7.01699 3.4807 8.24769 4.99884 8.24769Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_20220_19643">
            <rect
              width="10"
              height="10"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  } else if (symbol === "X") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="11"
        viewBox="0 0 10 11"
        fill="none"
      >
        <g clipPath="url(#clip0_20220_19649)">
          <path
            d="M0.0546875 3.84939C0.0546875 2.02762 1.53153 0.550781 3.3533 0.550781H6.65191C8.47368 0.550781 9.95052 2.02762 9.95052 3.84939V7.148C9.95052 8.96978 8.47368 10.4466 6.65191 10.4466H3.3533C1.53153 10.4466 0.0546875 8.96978 0.0546875 7.148V3.84939Z"
            fill="var(--red40)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.63198 7.15971C2.43517 7.35652 2.43517 7.6756 2.63198 7.87241C2.82879 8.06921 3.14787 8.06921 3.34468 7.87241L5.00391 6.21318L6.66362 7.87289C6.86042 8.0697 7.17951 8.0697 7.37631 7.87289C7.57312 7.67608 7.57312 7.357 7.37631 7.16019L5.71661 5.50048L7.37631 3.84077C7.57312 3.64397 7.57312 3.32488 7.37631 3.12807C7.17951 2.93127 6.86042 2.93127 6.66362 3.12807L5.00391 4.78778L3.34468 3.12856C3.14787 2.93175 2.82879 2.93175 2.63198 3.12856C2.43517 3.32536 2.43517 3.64445 2.63198 3.84126L4.29121 5.50048L2.63198 7.15971Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_20220_19649">
            <rect
              width="10"
              height="10"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  } else {
    return <DebateAlpabetIcon alphabet={symbol} />;
  }
};

// 선택지 옵션 텍스트 컬러 (의견,댓글)
export const getOptionColor = (symbol: string) => {
  if (symbol === "O") {
    return "text-blue50";
  } else if (symbol === "X") {
    return "text-red40";
  } else {
    return "text-gray70";
  }
};
// 선택지 옵션 BG 컬러 (의견,댓글)
export const getOptionBgColor = (symbol: string) => {
  if (symbol === "O") {
    return "bg-blue5";
  } else if (symbol === "X") {
    return "bg-red5";
  } else {
    return "bg-gray5";
  }
};

// 특정 선택지 비율 계산
// 특정 선택지 비율 계산
//Math.round
export const getChoicePercentage = (totalVotes: number, votes: number) => {
  if (totalVotes === 0) return "0%";
  return Number(((votes / totalVotes) * 100).toFixed(1)) + "%";
};

export const transitionHeightStyle = (
  isVisible: boolean,
  waitingHeight: number | null,
  delay: number = 3,
  addClassName: string = ""
) => {
  // style={{
  //   height: isVisible
  //     ? waitingHeight
  //       ? `${waitingHeight + 59}px`
  //       : `${218}px`
  //     : `${waitingHeight}px`,
  //   transition: "height 0.6s ease-out 3s",
  // }}
  // className="overflow-hidden"
  return {
    style: {
      height: isVisible
        ? waitingHeight
          ? `${waitingHeight + 59}px`
          : `${218}px`
        : `${waitingHeight}px`,
      transition: `height 0.6s ease-out ${delay}s`,
    },
    className: `overflow-hidden ${addClassName}`,
  };
};

// 디베이트 지니어스 썸네일 이미지
export const getDebateThumbnail = (
  url?: string,
  discussId?: number
): string => {
  if (url) {
    return url;
  }
  const pathList = Array.from(
    { length: 6 },
    (_, index) => `/images/debate/ai-report-temp${index + 1}.webp`
  );

  if (discussId !== undefined) {
    // discussId를 사용하여 일관된 이미지 선택
    const index = Math.abs(discussId) % pathList.length;
    return pathList[index];
  }

  // discussId가 없는 경우에만 랜덤 선택
  const randomIndex = Math.floor(Math.random() * pathList.length);
  return pathList[randomIndex];
};
